import { BrandColors } from "../../styles/BrandColors";

const { JLLBrandColors } = BrandColors;

const { Red } = JLLBrandColors;

export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "absolute",
    top: 75,
    left: 0,
    right: 0,
    bottom: 0,
  },
  messageContainer: {
    flex: 0.9,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  messagePrimary: {
    margin: "1em",
    fontFamily: "Source Sans Pro",
    fontSize: 16,
    textAlign: "center",
  },
  messageSecondary: {
    color: "rgba(0, 0, 0, 0.3)",
    margin: "1em",
    fontFamily: "Source Sans Pro",
    fontSize: 12,
    textAlign: "center",
  },
  messageLink: {
    color: "rgba(0, 0, 0, 0.3)",
    margin: "1em",
    fontFamily: "Source Sans Pro",
    fontSize: 12,
    textAlign: "center",
    cursor: "pointer"
  },
  icon: {
    fontSize: "3em",
    color: Red,
  },
};
